import * as React from 'react';
import styled from 'styled-components';
import { memoizeFunction } from '@agilepoint/utils-common';
import { Callout } from '../../callout';
import { ListView } from '../../listview';
import { ListIterator } from '../../../utils';
import { ITagInputOption } from '../tag-input-types';

export interface IPickerProps {
    hidden: boolean;
    items: ITagInputOption[];
    itemsIterator: ListIterator<any>;
    selectedValues: ITagInputOption[];
    listViewRef: React.RefObject<HTMLDivElement>;
    targetRef: React.RefObject<HTMLDivElement>;
    onDismiss: () => void;
    onChange: (selectedItems: string[]) => void;
    canSelectItem?(item: string): boolean;
}

const StyledCallout = styled(Callout)`
    & .ap-callout-content {
        overflow: hidden;
    }
`;

const StyledListView = styled(ListView)`
    display: block;
    height: 176px;
    &:focus {
        outline: none;
    }
    & .ap-listView-itemContentWrapper {
       border: none;
    }
`;

const ListViewOption = styled.div.attrs(() => ({
    className: String('ap-taginput-option')
}))`
    padding: 7px 24px;
`;

const Text = styled.span.attrs(() => ({
    className: String('ap-taginput-optionText')
}))`
    padding-left: 5px;
`;

const getMarkupForItem = memoizeFunction(({ text }: ITagInputOption): JSX.Element => (
    <ListViewOption>
        <Text>
            {text}
        </Text>
    </ListViewOption>
));

export function Picker(props: IPickerProps) {
    const { targetRef, hidden, onDismiss, items, listViewRef, onChange, canSelectItem, itemsIterator } = props;
    return (
        <StyledCallout
            targetRef={targetRef}
            animateOnOpen
            onDismiss={onDismiss}
            useTargetsWidth
            preventClickEventPropagation
            hidden={hidden}>

            <StyledListView
                selectable="multiple"
                itemHeight={35}
                items={items}
                keyProp="value"
                itemsIterator={itemsIterator}
                elementRef={listViewRef}
                allowKeyboardNavigation
                onChange={onChange}
                onRenderItemContent={getMarkupForItem}
                canSelectItem={canSelectItem} />
        </StyledCallout>
    );
}
